import script from "./SitesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SitesView.vue?vue&type=script&setup=true&lang=js"

import "./SitesView.vue?vue&type=style&index=0&id=652a7b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652a7b60"]])

export default __exports__